// system
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

// services
import { DisplayMessageToUserService } from './display-to-user-message.service';
import { ClearDataService } from "../services/clear-data.service";


// interfaces
import { MatchCities } from '../interfaces/match-cities.interface';
import { City } from '../interfaces/city.interface';
import { Street } from '../interfaces/street.interface';
import { PostOfficeInfo } from '../interfaces/post-office-info.interface';
import { Day } from "../interfaces/day.interface";




@Injectable({
  providedIn: 'root'
})
export class ApiRequestService {

  //private api_url: string = "https://sss45ss.ss/requests/controller.php" // for openserver php
  //private api_url: string = "/requests/controller.php" // document.location.origin + 

  private api_url: string = "https://offices.ukrposhta.ua/requests/controller.php";

  private cityByNamePrefixSubject: BehaviorSubject<MatchCities> = new BehaviorSubject<MatchCities>(null)
  //private postofficesByPostindex: BehaviorSubject
  private schedule: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private postoffices: {} = {};
  private postOfficeInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private displayMessage: DisplayMessageToUserService,
    private clear: ClearDataService
  ) {
    //console.log(document.location.origin)
    if (document.location.origin.includes('localhost'))
      this.api_url = "https://offices.ukrposhta.ua/requests/controller.php";
    else
      this.api_url = document.location.origin + "/requests/controller.php";
  }

  public getCityByPrefixSubject(): BehaviorSubject<MatchCities> {
    return this.cityByNamePrefixSubject;
  }

  

  public async sendRequestForCitiesByPrefix(city_prefix: string) {

    let address: string = this.api_url + '?method=get_city_by_region_id_and_district_id_and_city_ua&city_ua=' + city_prefix;

    let responseCities = [];

    await this.http.get(address)

      .subscribe((cities: any) => {

        if (cities != {}) { // need investigate if this needed // mb use empty obj check

          if (!cities.error) {

            responseCities = cities;

            let a = responseCities.sort((a: any, b: any) => {

              let result = -(- b.POPULATION) - a.POPULATION < 0 ? -1 : -(- b.POPULATION) == -(- a.POPULATION) ? 0 : 1;

              return result;
            })

            let amountOfCitiesWithMachingNameToPrefix = cities.filter((c: City) => {
              return c.CITY_UA.trim().toLocaleLowerCase() == city_prefix.toLocaleLowerCase()
            }).length;

            this.cityByNamePrefixSubject.next({
              cities: responseCities, //cities,
              citiesCount: responseCities.length, //cities.length,
              cityPrefix: city_prefix,
              isPrefixMatchOnlyOneCity: amountOfCitiesWithMachingNameToPrefix == 1 ? true : false
            });
            this.displayMessage.displayMessageOnMap(false);
          } else {
            // error
            //console.error('cities: ', responseCities);
            let errorText = this.displayMessage.getCurrentLang().errors.noCitiesByCurrentPrefix;
            this.displayMessage.displayMessageOnMap(true, errorText);
            this.clear.emitClearObjectOptional({ Map: true, Dropdown: true, previewList: true, previewSelected: true })
          }

        }

      });

  }//  sendRequestForCitiesByPrefix



  public async getPostOfficeInfoByIndex(postCode: string): Promise<Array<any>> {

    let result;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address = this.api_url + '?method=get_postoffices_by_postindex_web&pc=' + postCode

    await this.http.get(address).toPromise().then(
      postoffice => {
        result = postoffice;
      })

   

    return result;
  }

  // 29.04.2026 NEW CODE FRAGMENT, OPENHOURS FIX (START)
  public async getSchaduleByPostCode(postCode: string, officeId: string = '') {
    let address: string = this.api_url + '?method=get_postoffices_openhours_by_postindex&pc=' + postCode;

    let response: any = await this.http.get(address).toPromise().then(schadules => {
      let result = this.unwrapResponseToArray(schadules);
      if (result && result[0] && result[0].error) return null;
      return result;
    });

    if ((!response || response.length === 0) && officeId) {
      let idAddress = 'https://www.ukrposhta.ua/address-classifier/get_postoffices_openhours_by_id?id=' + officeId;
      await this.http.get(idAddress).toPromise().then((data: any) => {
        if (data && data.Entries && data.Entries.Entry) {
          response = Array.isArray(data.Entries.Entry) ? data.Entries.Entry : [data.Entries.Entry];
        }
      });
    }

    if (!response || response.length === 0) return [];

    let W_days: Array<any> = [];
    let D_days: Array<any> = [];

    // Розділяємо робочі часи (W) та перерви (D)
    for (let i = 0; i < response.length; i++) {
      if (response[i].INTERVALTYPE && response[i].INTERVALTYPE.trim() === 'W') {
        W_days.push(response[i]);
      } else {
        D_days.push(response[i]);
      }
    }

    // Прив'язуємо перерви до відповідних робочих інтервалів
    for (let i = 0; i < W_days.length; i++) {
      const breakInfo = D_days.find(brk =>
        brk.DAYOFWEEK_NUM == W_days[i].DAYOFWEEK_NUM &&
        brk.id == W_days[i].id &&
        brk.DAYS_PERIOD == W_days[i].DAYS_PERIOD // Важливо для ПВ
      );

      if (breakInfo) {
        W_days[i].BREAKTFROM = breakInfo.TFROM;
        W_days[i].BREAKTTO = breakInfo.TTO;
      } else {
        W_days[i].BREAKTFROM = null;
        W_days[i].BREAKTTO = null;
      }
    }

    const normalizedDays: any[] = [];

    for (const day of W_days) {
      if (day.ISVPZ === '1') {
        normalizedDays.push(day);
      } else {
        const existingIdx = normalizedDays.findIndex(d => 
          d.DAYOFWEEK_NUM === day.DAYOFWEEK_NUM && d.ISVPZ !== '1'
        );

        if (existingIdx === -1) {
          normalizedDays.push(day);
        } else {
          const existing = normalizedDays[existingIdx];
          const existingDur = parseInt(existing.TTO.replace(':', '')) - parseInt(existing.TFROM.replace(':', ''));
          const newDur = parseInt(day.TTO.replace(':', '')) - parseInt(day.TFROM.replace(':', ''));

          if (newDur > existingDur) {
            normalizedDays[existingIdx] = day;
          }
        }
      }
    }

    return normalizedDays;
  }

  public async getPostOfficeInfoAndSchaduleByIndex(postCode: string) {
    console.log("Пошук для індексу:", postCode);

    const info = await this.getPostOfficeInfoByIndex(postCode);

    if (!info || (info as any).error || info.length === 0) {
      let error = this.displayMessage.getCurrentLang().errors.wrongPostCode;
      this.displayMessage.displayMessageOnMap(true, error);
      return [];
    }

    let selectedOffice = info.find(o =>
      String(o.POSTCODE || o.POSTINDEX).trim() === String(postCode).trim()
    );

    if (!selectedOffice) selectedOffice = info[0];

    const officeId = selectedOffice.ID;
    const isPV = selectedOffice.ISVPZ === '1' || selectedOffice.POSTOFFICE_TYPE === 'ПВ';
    
    const schedule = await this.getSchaduleByPostCode(postCode, officeId);

    // 1. Фільтрація за офісом та населеним пунктом (для ПВ)
    let respectiveSchadule = schedule.filter(day => {
      const isSameOffice = String(day.id) === String(officeId);
      if (isPV) {
        const isSameCityId = String(day.CITY_ID) === String(selectedOffice.CITY_ID);
        const isSameCityName = (day.CITY_UA || "").trim().toLowerCase() === (selectedOffice.CITY_UA || "").trim().toLowerCase();
        return isSameOffice && (isSameCityId || isSameCityName);
      }
      return isSameOffice;
    });

    // 2. Фільтрація ЗА ПЕРІОДОМ МІСЯЦЯ (Щоб прибрати дублікати четвергів/п'ятниць)
    const today = new Date();
    const todayDate = today.getDate();

    if (isPV) {
      respectiveSchadule = respectiveSchadule.filter(day => {
        // Якщо періоду немає, залишаємо запис
        if (!day.DAYS_PERIOD) return true;

        const match = day.DAYS_PERIOD.match(/\d+/g);
        const numbers = match ? match.map(Number) : null;

        if (numbers && numbers.length >= 2) {
          for (let i = 0; i < numbers.length; i += 2) {
            const start = numbers[i];
            const end = numbers[i + 1] || start;
            // Перевіряємо, чи сьогоднішнє число входить у цей діапазон
            if (todayDate >= start && todayDate <= end) return true;
          }
          // Якщо число не входить у жоден діапазон цього запису — видаляємо його зі списку
          return false;
        }
        return true;
      });
    }

    // 3. Сортування та присвоєння розкладу
    respectiveSchadule.sort((a, b) => Number(a.DAYOFWEEK_NUM) - Number(b.DAYOFWEEK_NUM));
    selectedOffice.schedule = respectiveSchadule;

    // 4. Визначення поточного робочого дня
    const todayDayNum = today.getDay() === 0 ? 7 : today.getDay();
    const currentDay = respectiveSchadule.find(day => Number(day.DAYOFWEEK_NUM) === todayDayNum);

    selectedOffice.currentDay = currentDay || null;

    this.displayMessage.displayMessageOnMap(false);
    return [selectedOffice];
  }
  // 29.04.2026 NEW CODE FRAGMENT, OPENHOURS FIX (END)


  public async getPostOfficeInfoByCityId(cityID: string) {

    
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address: string = 'https://www.ukrposhta.ua/address-classifier/get_postoffices_postdistricts_web?pdCityId=' + cityID;
    // let address: string = this.api_url + '?method=get_postoffices_by_city_id&city_id=' + cityID;

    // let address: string = this.api_url + '?method=get_postoffices_postdistricts_web?pdCityId=' + cityID;

    let response;
    await this.http.get(address).toPromise().then(postoffice => {


      postoffice = this.unwrapResponseToArray(postoffice);
      response = postoffice;
    })

    // console.log(response)

    return response;

  }


  public async getSchaduleByCityId(cityID: string) {

    let address: string = this.api_url + '?method=get_working_schedule_by_city_id&city_id=' + cityID;
    // let address: string = 'https://ukrposhta.ua/address-classifier/get_postoffices_postdistricts_web?pdCityId=' + cityID;
    let response;
    await this.http.get(address).toPromise().then(schadules => {

      schadules = this.unwrapResponseToArray(schadules);
      response = schadules;
    })

    return response;

  }


  public async getScheduleVpzById(id: string) {

    let address: string = 'https://www.ukrposhta.ua/address-classifier/get_postoffices_openhours_by_id?id=' + id;
    
    // let address: string = '';

    let response;

      await this.http.get(address).toPromise().then(data => {

      let value;
      
      value = data;

      response = value.Entries.Entry;

    });

    return response;

  }


  public async getSchaduleForPostofficesByCityId(cityID: string) {

    let address: string = this.api_url + '?method=get_postoffices_by_city_id&city_id=' + cityID;
    let response;

    await this.http.get(address).toPromise().then(postofficesSchadules => {
      postofficesSchadules = this.unwrapResponseToArray(postofficesSchadules);
      response = postofficesSchadules;
    })

    return response;

  }

  public async getPostOfficesAndSchadulesByCityId(cityID: string) {

    let response;

    await Promise.all([
      this.getPostOfficeInfoByCityId(cityID),
      this.getSchaduleByCityId(cityID),

    ]).then((values) => {

    
      //  console.log(values)

    
      if (!(values[0] as any)[0].error) {

        let offices = values[0];
        let schadules = values[1];
        let scadulesKeyValue = {};
        let breakKeyValue = {};

        var d = new Date();
        var n = d.getDay();

        schadules.forEach((day: {
          DAYOFWEEK_SHORTNAME_UA: string,
          DAYOFWEEK_UA: string,
          INTERVALTYPE: string,
          PARENT_ID: string,
          POSTCODE: string,
          POSTINDEX: string,
          TECHINDEX: string,
          TFROM: string,
          TTO: string,
          city_id: string,
          id: string,
          pdcity_id: string
        }) => {

          let postofficeId = day.id;
          if (day.pdcity_id == cityID) {

            if (day.INTERVALTYPE.trim() == "W") { // working interval
              if (!scadulesKeyValue[postofficeId])
                scadulesKeyValue[postofficeId] = [];

              if (day.TTO.trim() == '00:00') {
                // in merezha from 00:00 to 24:00 exist as 0000 0000

                day.TTO = '24:00'
              }
              scadulesKeyValue[postofficeId].push(day);
            } else { // breaks 
              if (!breakKeyValue[postofficeId])
                breakKeyValue[postofficeId] = [];

              breakKeyValue[postofficeId].push(day);

            }

          } else {
            ///console.error('wrong postID ', day.pdcity_id, cityID)
          }
        });

        // write breaks into same day 
        Object.keys(breakKeyValue).forEach(officeID => { // for each office

          let breaks: [] = breakKeyValue[officeID];

          breaks.forEach((breakDay: any) => { // for each day ( break object )
            if (scadulesKeyValue[officeID]) {
              for (let i = 0; i < scadulesKeyValue[officeID].length; i++) { // find respective W  working time object

                if (scadulesKeyValue[officeID][i].DAYOFWEEK_UA == breakDay.DAYOFWEEK_UA) {
                  scadulesKeyValue[officeID][i].BREAKTFROM = breakDay.TFROM
                  scadulesKeyValue[officeID][i].BREAKTTO = breakDay.TTO

                  //if( n == scadulesKeyValue[officeID][i].DAYOFWEEK_NUM ) // change at midnight
                  //respectiveOffice.currentDay = scadulesKeyValue[officeID][i]
                  break;
                }
              }


            }
          })

        })


        Object.keys(scadulesKeyValue).forEach(officeIdFromSchadule => {
          let respectiveOffice = offices.find(office => {
            return office.ID == officeIdFromSchadule;
          });

          if (respectiveOffice) {

            const isPV =
              respectiveOffice.ISVPZ === '1' ||
              respectiveOffice.POSTOFFICE_TYPE === 'ПВ';

            let schedule = scadulesKeyValue[officeIdFromSchadule];

            // 🔹 1. Фільтр по місту (як у пошуку по індексу)
            if (isPV) {
              schedule = schedule.filter((day: any) => {
                const isSameCityId =
                  String(day.CITY_ID) === String(respectiveOffice.CITY_ID);

                const isSameCityName =
                  (day.CITY_UA || '').trim().toLowerCase() ===
                  (respectiveOffice.CITY_UA || '').trim().toLowerCase();

                return isSameCityId || isSameCityName;
              });
            }

            // 🔹 2. Фільтр по DAYS_PERIOD (КЛЮЧОВЕ!)
            const today = new Date();
            const todayDate = today.getDate(); // Сьогодні 30-те

            if (isPV) {
              schedule = schedule.filter((day: any) => {
                const periodStr = day.DAYS_PERIOD;
                
                // Якщо період порожній або "Щодня" — залишаємо
                if (!periodStr || periodStr === "null" || periodStr.trim() === "" || periodStr.toLowerCase().includes("щодня")) {
                  return true;
                }

                // Очищаємо рядок від "З", "по", лишаючи цифри та роздільники
                const cleanStr = periodStr.toLowerCase()
                  .replace(/[^0-9\sта,;-]/g, '')
                  .replace(/\s+/g, ' ');

                // Розбиваємо на частини (наприклад, "1-9" та "26-31")
                const parts = cleanStr.split(/та|,|;/);

                return parts.some(part => {
                  const numbers = part.match(/\d+/g);
                  if (!numbers) return false;

                  const nums = numbers.map(Number);
                  
                  if (nums.length >= 2) {
                    // Перевіряємо, чи сьогоднішнє число (30) входить у діапазон
                    return todayDate >= nums[0] && todayDate <= nums[nums.length - 1];
                  } else if (nums.length === 1) {
                    // Перевіряємо конкретний день
                    return todayDate === nums[0];
                  }
                  return false;
                });
              });
            }

            respectiveOffice.schedule = schedule;

            const n = today.getDay() === 0 ? 7 : today.getDay();

            let todaysSchadule = schedule.filter(day => {
              return Number(day.DAYOFWEEK_NUM) === n;
            });

            respectiveOffice.currentDay =
              todaysSchadule && todaysSchadule.length
                ? todaysSchadule[0]
                : null;
          }
        });

        const cityOffice: Array<PostOfficeInfo> = values[0].filter((offc: PostOfficeInfo) => {
          return offc.TYPE_ACRONYM.toLocaleUpperCase().includes('мв')
        });
        const villageOffice: Array<PostOfficeInfo> = values[0].filter((offc: PostOfficeInfo) => {
          return offc.TYPE_ACRONYM.toLocaleUpperCase().includes('св')
        });
        const centralOffice: Array<PostOfficeInfo> = values[0].filter((offc: PostOfficeInfo) => {
          return offc.TYPE_ACRONYM.toLocaleUpperCase().includes('цв')
        });
        const mobileOffice: Array<PostOfficeInfo> = values[0].filter((offc: PostOfficeInfo) => {
          return offc.TYPE_ACRONYM.toLocaleUpperCase().includes('пв')
        });

        const isPVPZpresent = mobileOffice.length > 0 ? true : false;

        if (isPVPZpresent) {


          if (centralOffice.length > 0) {
            offices = centralOffice
          } else {
            // if (cityOffice.length > 0) {
            //   offices = cityOffice
            // } else {
              // if (villageOffice.length) {
              //   offices = villageOffice
              // } else { }
            // }
          }

        }

        response = offices;

        this.displayMessage.displayMessageOnMap(false);
      } else {
        let error = this.displayMessage.getCurrentLang().messages.noOfficesInCurrentCity;
        this.displayMessage.displayMessageOnMap(true, error);
      }
    });
    return response;
  }


  public unwrapResponseToArray(some: any): [any] {

    if (some && !some.Entry && !some.Entries && some.length && some.length > 0)
      return some;

    let result;

    if (some && some.Entry)
      result = some.Entry

    if (some && some.Entries && some.Entries.Entry)
      result = some.Entries.Entry

    if (some == undefined ||
      (Array.isArray(some) && (some.length == 0)))
      return undefined;

    if (some && (typeof some) == 'object' && !some.Entry && !some.Entries)
      return [some]

    if (result && !Array.isArray(result) || (typeof result) == 'object' && !result.length)
      result = [result]

    return result;
  } // unwrapResponseToArray



  public async getPostOfficeScheduleByIndex(postCode: number) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address = this.api_url + '?method=get_postoffices_openhours_by_postindex&pc=' + postCode

    await this.http.get(address)
      .subscribe((resp: any) => {
        let schaduleDays = this.unwrapResponseToArray(resp);
        let resultOfficesArray = [];

        if (schaduleDays) {
          this.schedule.next(schaduleDays)
          let schedulesForPostOffices = {}
          let breakTimeDays = [];


          let W_timeDays = schaduleDays.filter(day => {
            return day.INTERVALTYPE.trim() == 'W'
          }) || [];

          let D_timeDays = schaduleDays.filter(day => {
            return day.INTERVALTYPE.trim() == 'D' && day.TFROM.trim() != "00:00".trim() && day.TTO.trim() != "00:00".trim() // shity data check
          }) || [];

          for (let i = 0; i < W_timeDays.length; ++i) {

            if (!schedulesForPostOffices.hasOwnProperty(W_timeDays[i].id)) {
              schedulesForPostOffices[W_timeDays[i].id] = [];
            }


            // find break for current day of week
            let respectiveBreak = D_timeDays.find(day => day.DAYOFWEEK_SHORTNAME_UA.trim() == W_timeDays[i].DAYOFWEEK_SHORTNAME_UA.trim())
            if (respectiveBreak)
              W_timeDays[i].break = "(" + respectiveBreak.TFROM + " - " + respectiveBreak.TTO + ")"
            schedulesForPostOffices[W_timeDays[i].id].push(W_timeDays[i])

          }



          // add schedule to postoffice object 
          for (let i = 0; i < schaduleDays.length; ++i) {

            if (!schedulesForPostOffices.hasOwnProperty(schaduleDays[i].id)) {
              schedulesForPostOffices[schaduleDays[i].id] = [];
            }
            if (schaduleDays[i].INTERVALTYPE.trim() == 'D') {
              if (schaduleDays[i].TFROM.trim() != "00:00".trim() && schaduleDays[i].TTO.trim() != "00:00".trim())
                breakTimeDays.push(schaduleDays[i])
            } else {
              let respectiveBreak = breakTimeDays.find(day => day.DAYOFWEEK_SHORTNAME_UA.trim() == schaduleDays[i].DAYOFWEEK_SHORTNAME_UA.trim())
              if (respectiveBreak)
                schaduleDays[i].break = "(" + respectiveBreak.TFROM + " - " + respectiveBreak.TTO + ")"

              schedulesForPostOffices[schaduleDays[i].id].push(schaduleDays[i])
            }

          }
          // add schedule to postoffice object 
          for (let i = 0; i < Object.keys(schedulesForPostOffices).length; ++i) {
            let currentOfficeId = Object.keys(schedulesForPostOffices)[i]
            if (this.postoffices.hasOwnProperty(currentOfficeId)) {
              this.postoffices[currentOfficeId].scadule = schedulesForPostOffices[currentOfficeId]
              resultOfficesArray.push(this.postoffices[currentOfficeId]);
            }
          }
          if (resultOfficesArray.length == 0) {

            let office = this.postoffices[Object.keys(this.postoffices)[0]]
            let selectScadule = schaduleDays.filter(function (day) {

              return day.POSTCODE == office.POSTCODE
            })
            this.postoffices[Object.keys(this.postoffices)[0]].scadule = selectScadule;
            resultOfficesArray.push(this.postoffices[Object.keys(this.postoffices)[0]]);

          }
          this.postOfficeInfo.next(resultOfficesArray)


          console.log(this.postOfficeInfo)

        } else {
          // add empty scadule 
          this.postoffices[Object.keys(this.postoffices)[0]].scadule = [];
          this.postOfficeInfo.next([this.postoffices[Object.keys(this.postoffices)[0]]])


        }

      });

  }






}



